<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="bu-location-header">
    <span class="bu-location-name">
        <span>Location&nbsp;</span>
        <winde-node-pointer
                [listData]="{ nodeNames: buLocation.getName(), placement: 'top', cropName: 10 }"
                class="bu-location-name"
        ></winde-node-pointer>
        , device azimuth {{ problematicBuData.deviceAzimuth + '\u00B0' }}
    </span>
</div>
BU neighbours:
<div class="bu-sectors-list">
    @for (sector of sectorData; track sector.sectorInDeviceId) {
        <div class="bu-sector-row">
            <span class="bu-sector-name">Sector {{ sector.sectorInDeviceViewValue }}:</span>
            <div class="bu-sector-nodes">
                <winde-node-pointer [listData]="{ nodeNames: sector.neighbourNames, separateBy: ', ', placement: 'top', cropName: 10 }">
                </winde-node-pointer>
            </div>
        </div>
    }
</div>
@if (blockedByPole) {
    Blocked by pole:
    <winde-node-pointer [listData]="{ nodeNames: blockedByPole, separateBy: ', ', placement: 'top', cropName: 10 }"></winde-node-pointer>
}
